export default [
  {
    value: 'listings_set',
    label: 'Listing Appointments Set',
  },
  {
    value: 'listings_held',
    label: 'Listing Appointments Held',
  },
  {
    value: 'listings_taken',
    label: 'Listing Appointments Taken',
  },
  {
    value: 'listings_sold',
    label: 'Listings Sold',
  },
  {
    value: 'listing_nurtures',
    label: 'Listing Nurtures',
  },
  {
    value: 'buyers_set',
    label: 'Buyer Appointments Set',
  },
  {
    value: 'buyers_held',
    label: 'Buyer Appointments Held',
  },
  {
    value: 'buyers_signed',
    label: 'Buyers Signed',
  },
  {
    value: 'buyers_sold',
    label: 'Buyers Sold',
  },
  {
    value: 'buyer_nurtures',
    label: 'Buyer Nurtures',
  },
  {
    value: 'price_correction',
    label: 'Price Correction',
  },
  {
    value: 'offers_written',
    label: 'Offers Written',
  }
];